import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function ModalPuxaMaterialPadrao({ show, setMostrarModalMaterialPadrao, generateMaterialPadrao }) {
  // const [tempoRestante, setTempoRestante] = useState(5); // 5 segundos para desfazer a ação
  // const [timer, setTimer] = useState(null); // Declaração da variável timer
  // const [isVisible, setIsvisible] = useState(show); // Declaração da variável timer

  const handleOK = () => {
    // setTextoModalCompilacao('');
    generateMaterialPadrao();
    setMostrarModalMaterialPadrao(false);
    // onCloseModalCallback();
    // setTempoRestante(5);
  };

  return (
    // <div className={`modal ${show ? 'fade-slide-enter' : 'fade-slide-exit'}`}>
    <div>
    <Modal show={show}
          //  backdrop="true"
           size="lg"
           centered={true}
          //  dialogClassName="bottom-right-modal"
          //  contentClassName="modal3"
          >
      <Modal.Dialog 
          //  contentClassName="modal3"
           style={{margin:0}}>
        {/* <Modal.Header closeButton>
          <Modal.Title>Modal title</Modal.Title>
        </Modal.Header> */}

        <Modal.Body>
          {/* {texto} */}
          <br/>
          <p>Você está prestes a visualizar o material padrão para este módulo.
          <br/>
          <br/> Caso você opte por utilizar este material, basta salvar ou compilar após a execução deste comando.
          <br/>
          <br/> Para retornar ao seu material deste módulo, NÃO SALVE OU COMPILE com o material padrão, e selecione o módulo novamente.
          <br/> 
          </p>
          {/* <ProgressBar variant="info" animated now={Math.ceil(tempoRestante/5)} /> */}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="dark" onClick={handleOK}>Continuar</Button>
          <Button variant="primary" onClick={() => setMostrarModalMaterialPadrao(false)}>Cancelar</Button>
        </Modal.Footer>
      </Modal.Dialog>
      {/* <div className="modal-content">
        <p>Desfazer em {tempoRestante} segundos</p>
        <button onClick={desfazer}>Desfazer</button>
      </div> */}
      </Modal>
    </div>
  );
}

export default ModalPuxaMaterialPadrao;